import { shallowEqual } from 'react-redux';

import { useQuery } from '@zg-rentals/react-query5';
import {
  RentalManagerGuestSupportWebApiHandler_getHelpArticles,
  RentalManagerGuestSupportWebApiHandler_getHelpTopics,
  RentalManagerUserSupportWebApiHandler_getHelpArticles,
  RentalManagerUserSupportWebApiHandler_getHelpTopics,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

import { useSelector } from '../../selectors/useSelector';

import { HelpArticles } from '../../model/HelpArticles';
import { HelpTopicsList } from '../../model/HelpTopics';

import type { HelpArticlesProps } from '../../model/HelpArticles';
import type { HelpTopicsListProps } from '../../model/HelpTopics';

/**
 * Gets support articles by category and topic
 *
 * @param {string} [category]
 * @param {string} [topic]
 */
export const useGetHelpArticles = ({ category = '', topic = '' }, queryOptions = {}) => {
  const { loggedIn } = useSelector((state) => ({ loggedIn: state.user.loggedIn }), shallowEqual);

  return useQuery<HelpArticlesProps, Error>({
    queryKey: ['getHelpArticles', category, topic],
    queryFn: async () => {
      const getParams = { category, topic };
      const data = await (loggedIn
        ? RentalManagerUserSupportWebApiHandler_getHelpArticles(getParams)
        : RentalManagerGuestSupportWebApiHandler_getHelpArticles(getParams));
      return HelpArticles(data);
    },

    ...queryOptions,
    staleTime: 10 * 60 * 1000,
  });
};

/**
 * Gets all help topics by category
 */
export const useGetHelpTopics = ({ isLoggedIn = false }, queryOptions = {}) => {
  return useQuery<HelpTopicsListProps, Error>({
    queryKey: ['getHelpTopics'],
    queryFn: async () => {
      const data = await (isLoggedIn
        ? RentalManagerUserSupportWebApiHandler_getHelpTopics()
        : RentalManagerGuestSupportWebApiHandler_getHelpTopics());
      return HelpTopicsList(data);
    },
    ...queryOptions,
    staleTime: 10 * 60 * 1000,
  });
};
